import config from "../src/config";

function hasExpired(key) {
  let createdAt = window.localStorage.getItem(key + config.localStorage.keyTTLSuffix);
  let ttl = config.localStorage.ttl;
  let expirationTime = parseInt(createdAt, 0) + parseInt(ttl, 0);
  let now = Date.now();
  if (expirationTime < now) {
    return true;
  }

  return false;
}

// Allows to determine if the local storage is available or not.
// Returns true if available, false otherwise
function isLocalStorageAvailable() {
    var storage;
    try {
        storage = window['localStorage'];
        var x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    }
    catch(e) {
        return e instanceof DOMException && (
            // everything except Firefox
            e.code === 22 ||
            // Firefox
            e.code === 1014 ||
            // test name field too, because code might not be present
            // everything except Firefox
            e.name === 'QuotaExceededError' ||
            // Firefox
            e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
            // acknowledge QuotaExceededError only if there's something already stored
            (storage && storage.length !== 0);
    }
}

export const storage = {
  put(key, value) {
    if (isLocalStorageAvailable()) {
      window.localStorage.setItem(key, value);
      window.localStorage.setItem(key + config.localStorage.keyTTLSuffix, Date.now());
    } else {
      console.log('Local storage is not available on this browser.');
    }
  },
  get(key) {
    if (isLocalStorageAvailable()) {
      let value = window.localStorage.getItem(key);
      if (value && !hasExpired(key)) {
        return value;
      }
    } else {
      console.log('Local storage is not available on this browser.');
    }
    return null;
  },
  remove(key) {
    if (isLocalStorageAvailable()) {
      window.localStorage.removeItem(key);
    }
  },
  clearAll() {
    if (isLocalStorageAvailable()) {
      window.localStorage.clear();
    }
  }
};

export default storage;
